<template>
  <div class="page_footer">
    <div class="foot_body">

    <div class="site_info">

      <div class="site_intro">
        <div class="si_top">
          <img src="../../assets/footlogo.png">
        </div>
        <div class="si_phone">
        <div class="si_bot1">TEL</div>
        <div class="si_bot2">400-178-1617</div>
        </div>
      </div>

      <div class="site_map">

        <div class="map_list" v-for="item in itemLi">
          <div class="d_span">
          <span class="foot_span">{{item.span}}</span>
          </div>
        <div class="d_a" v-for="item2 in item.aa">
          <a class="foot_a"  :href="item2.hrf" >{{item2.text1}}</a>
      </div>
        </div>


      </div>

    </div>
    <div class="foot_last">
    <div id="footer" class="foot_d">
      京ICP备2024091723号-1  京公网安备11011302007356号
      本网站版权归微创未来（北京）激光技术有限公司所有
    </div>
<!--      <div class="foot_t">-->
<!--        <img class="foot_img_l" src="../assets/image/t1.png">-->
<!--        <img class="foot_img_l" src="../assets/image/t2.png">-->
<!--        <img class="foot_img_l" src="../assets/image/t3.png">-->
<!--        <img class="foot_img_l" src="../assets/image/t4.png">-->

<!--      </div>-->
    </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'abc',
  data() {
    return {
      itemLi:[
        {
          span :"Contact Us",
          aa:[
            {
              text1:"Contact Information",
              hrf:"/en/contactUs",
            },
            // {
            //   text1:"留言反馈",
            //   hrf:"/news2",
            // }
          ]
        }
        // ,
        // {
        //   span :"招贤纳士",
        //   aa:[
        //     {
        //       text1:"职位招聘",
        //       hrf:"/news2",
        //     }
        //   ]
        // }
        // ,
        // {
        //   span :"学术中心",
        //   aa:[
        //     {
        //       text1:"激光科普",
        //       hrf:"/news2",
        //     }
        //   ]
        // }
        ,{
          span :"News Center",
          aa:[
            {
              text1:"Company News",
              hrf:"/en/news2",
            },
            // {
            //   text1:"行业资讯",
            //   hrf:"/news2",
            // }
          ]
        },
        {
          span :"Product Center",
          aa:[
            {
              text1:"Er:YAG Dental Laser Treatment System",
              hrf:"/en/product",
            },
            {
              text1:"Technical Features",
              hrf:"/en/product",
            },
            {
              text1:"Clinical Applications",
              hrf:"/en/product",
            },
            {
              text1:"Equipment Parameters",
              hrf:"/en/product",
            }
          ]
        },
        {
          span :"About Us",
          aa:[
            {
              text1:"Company Profile",
              hrf:"/en/aboutUs?path=gsjj",
            },
            {
              text1:"Development History",
              hrf:"/en/aboutUs?path=fzlc",
            },
            // {
            //   text1:"企业文化",
            //   hrf:"/aboutUs",
            // },
            // {
            //   text1:"客户口碑",
            //   hrf:"/aboutUs",
            // },
            {
              text1:"Company Qualifications",
              hrf:"/en/aboutUs?path=hxys",
            }
          ]
        }





      ]
    }
  }
}
</script>

<style scoped>
.foot_img_l{
  height: 30px;
  width: 30px;
  margin-right: 2px;
}
.foot_last{
  margin-top: 140px;
  display: flex;
}
.foot_t{
  width: 150px;
  height: 30px;
  margin-left: 450px;
}
.foot_d{
  font-family: SourceHanSansCN;
  font-size: 16px;
  color: #999999;
  text-align: justify;
  line-height: 34px;
  white-space: pre-wrap;
}
.d_a{
  width: 100%;
  display: flex;
}
.d_span{
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}
.map_list{
  float: right;
  width:189px;
}

.site_intro{
  margin-right: 60px;
}
.foot_a{
  font-family: SourceHanSansCN;
  font-size: 16px;
  color: #999999;
  text-align: center;
  line-height: 34px;
  width: 100%;
  cursor: pointer;
}
.foot_span{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  width: 100%;
}
.si_phone{
  margin-top: 80px;
}
.si_bot2{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #999999;
  text-align: justify;
  line-height: 34px;
}
.si_bot1{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #FFFFFF;
  text-align: justify;
}
.site_info{
  width: 100%;
  height: 220px;
  margin-top: 100px;
  display: flex;
}
.foot_body{
  width: 1400px;
}
.page_footer{
  height: 568px;
  width: 1920px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/en/Footer.vue